export class FabricanteRequest {
  versao: string;
  versaoResulth: string;
  arquivo: File;
  idUsuarioAdmin: number;
}
